import { render, staticRenderFns } from "./BillHome.vue?vue&type=template&id=10b54470&scoped=true&"
import script from "./BillHome.vue?vue&type=script&lang=js&"
export * from "./BillHome.vue?vue&type=script&lang=js&"
import style0 from "./BillHome.vue?vue&type=style&index=0&id=10b54470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b54470",
  null
  
)

export default component.exports